import {KeyboardEvent} from "./events/KeyboardEvent";

export namespace KeyboardEventDispatcher {

    import Stage = createjs.Stage;

    let _stage: Stage;

    const eventType = {
        keydown: "keydown",
        keypress: "keypress",
        keyup: "keyup"
    };
    const jsToAS3eventsMapping: { [key: string]: string | undefined } = {
        "keydown": KeyboardEvent.KEY_DOWN,
        "keyup": KeyboardEvent.KEY_UP
    };

    export function init(stage: Stage) {
        _stage = stage;
        addListeners();
    }

    function addListeners() {
        window.addEventListener(eventType.keydown, eventHandler);
        window.addEventListener(eventType.keypress, eventHandler);
        window.addEventListener(eventType.keyup, eventHandler);
    }

    export function convertEvent(event: any, bubbles: boolean | undefined = undefined): KeyboardEvent {
        const newEventEventType = jsToAS3eventsMapping[event.type] || event.type;

        const result: KeyboardEvent = new KeyboardEvent(newEventEventType, (bubbles !== undefined ? bubbles : event.bubbles), event.cancelable);

        result.ctrlKey = event.ctrlKey;
        result.altKey = event.altKey;
        result.shiftKey = event.shiftKey;
        result.keyCode = event.keyCode;
        result.charCode = event.charCode;
        result.key = event.key;
        result.code = event.code;
        result.which = event.which;
        result.target = event.target;
        result.currentTarget = event.currentTarget;

        return result;
    }

    const eventHandler: (event: Event) => void = function(event) {
        const createjsKeyboardEvent = convertEvent(event);
        _stage.dispatchEvent(createjsKeyboardEvent);
    };
}
